import React from 'react';
import classNames from 'classnames';
import Alert from '@johnlewispartnership/wtr-ingredients/dist/Alert';
import { summaryBoxShape } from '../../../../constants/data-shapes/competitions-form';
import commonStyles from '../../CompetitionsForm.module.scss';
const DuplicateEntry = ({ errors }) => {
    var _a;
    if (((_a = errors === null || errors === void 0 ? void 0 : errors.email) === null || _a === void 0 ? void 0 : _a.type) === 'duplicate-entry') {
        return (React.createElement("div", { "data-testid": "duplicateEntry", className: classNames(commonStyles.sectionWrapper, commonStyles.spacer) },
            React.createElement(Alert, { title: "You may only submit one entry", type: "error", message: errors.email.message })));
    }
    return null;
};
export default DuplicateEntry;
DuplicateEntry.propTypes = summaryBoxShape;
//# sourceMappingURL=DuplicateEntry.js.map